export default __webpack_public_path__ + "static/media/logo-JSA.b6e9110d.svg";